<template>
  <div
    id="rename-label-modal"
    class="modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <a
          data-dismiss="modal"
          href="javascript:;"
        >
          <XIcon class="w-8 h-8 text-gray-500" />
        </a>
        <div class="modal-body p-10">
          <div class="pl-5">
            <b>{{ $t("administration.Rename label") }}</b>
          </div>
          <div class="p-5 flex my-5">
            <span class="self-center w-2/5">{{ $t("administration.New name") }}: </span>
            <input
              v-model="newLabel.name"
              type="text"
              class="form-input intro-x login__input form-control border-gray-300 ml-8"
            >
          </div>
          <div class="p-5 flex my-5">
            <span class="self-center w-2/5">{{ $t("overview.Organization") }} ID: </span>
            <select
              v-model="newLabel.orgId"
              class="form-select intro-x login__input form-control border-gray-300 ml-8"
            >
              <option
                v-for="(organization, index) in organizations"
                :key="index"
                :value="organization.id"
                :selected="organization.id === newLabel.orgId"
              >
                {{ organization.name }}
              </option>
            </select>
          </div>
          <div class="px-5 pt-4 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="btn add-button"
              @click="addLabel"
            >
              {{ $t("administration.Rename") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toastify from 'toastify-js'
import AdministrationService from '@/services/AdministrationService'
import moment from 'moment-timezone'

export default {
  name: 'RenameLabelModal',
  props: {
    organizations: {
      type: Object,
      default() {
        return {}
      }
    },
    label: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  emits: ['renamed'],
  data() {
    return {
      newLabel: {},
    }
  },
  created() {
    this.moment = moment
    this.newLabel = this.label
  },
  methods: {
    addLabel(){
      AdministrationService.createUpdateLabel(this.newLabel)
          .then(response => {
            this.showToast('Label successfully renamed')
            this.$emit('renamed', this.newLabel)
            this.newLabel = {}
            this.closeModal()
          })
          .catch(err => {
            this.showToast('Label could not be renamed, please contact the Sysadmin of your organisation')
            this.closeModal()
          })
    },
    showModal() {
      this.newLabel = this.label
      cash('#rename-label-modal').modal('show')
    },
    closeModal() {
      cash('#rename-label-modal').modal('hide')
    },
    showToast(text) {
      Toastify({
        text: text,
        duration: 5000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true,
        className: 'toastify-content'
      }).showToast()
    },
    setData(label) {
      this.newLabel = label;
    }
  }
}
</script>
